import {TO_WIN} from '../ui-modules/sports-book/modules/racing/constants/identifiers';
import {WIN} from '../ui-modules/simplified/modules/racing/constants/identifiers';
import {RESULT_GAME_CARD} from '../ui-modules/simplified/modules/football/constants/identifiers';
import {ALL_FOOTBALL_MARKETS} from '../ui-modules/sports-book/modules/football/constants/marketTypes';
import {ALL_MATCHDAY_MARKETS} from '../ui-modules/sports-book/modules/matchday/constants/marketTypes';
import {ALL_FIRST_DOWN_MARKETS} from '../ui-modules/sports-book/modules/firstDown/constants/marketTypes';
import {ACTIVE_BETS_TAB} from '../ui-modules/simplified/constants/identifiers';
import {SORT_BY_ODD} from '../ui-modules/sports-book/modules/racing/constants/sortingTypes';
import {OPEN_BETS} from './identifiers';
import {OPERATOR} from './operator';
import {VIRTUALS} from './games';
import {isLocalStorageAvailable} from '../helpers/systemHelpers';
import {getItem} from "../helpers/localStorageHelpers";
import {VID_VISIBLE} from "./localStorage";
import {ALL_CRICKET_MARKETS} from "../ui-modules/sports-book/modules/cricket/constants/marketTypes";
import { ALL_BASEBALL_MARKETS } from '../ui-modules/sports-book/modules/baseball/constants/marketTypes';
import { ALL_TENNIS_MARKETS } from '../ui-modules/sports-book/modules/tennis/constants/marketTypes';

export default {
    //system handling
    playerUID: undefined,
    systemLanguage: OPERATOR.defaultLanguage,
    systemCurrency: OPERATOR.currency,
    isDesktopMode: true,
    hasTouchScreen: false,
    // game handling
    games: [],
    selectedGameIndex: 0,
    // event handling
    events: [],
    selectedEventId: 0,
    selectedEventIndex: 0,
    quickFillStake: '',
    quickFillBoxChecked: false,
    quickFillBoxDisabled: false,
    selectedMatchdaySubEventIndex: 0,
    nextEventsTimeStamp: [],
    noMoreBetsEventList: [],

    messageBar: {
        action: undefined,
        bet: undefined
    },

    // football modules
    footballMarketsExpanded: ALL_FOOTBALL_MARKETS.map((mkt) => true),

    // matchday modules
    matchdayMarketsExpanded: ALL_MATCHDAY_MARKETS.map((mkt) => true),

    // firstDown modules
    firstDownMarketsExpanded: ALL_FIRST_DOWN_MARKETS.map((mkt) => true),

    //racing modules
    selectedRacingBetType: OPERATOR.clientType === 'Simplified'
        ? WIN
        : TO_WIN,
    selectedFootballBetType: RESULT_GAME_CARD,
    selectedEventMultiBetList: OPERATOR.clientType === 'Simplified'
        ? []
        : [
            undefined, undefined, undefined, []
        ],
    selectedRaceCardSortField: SORT_BY_ODD,
    isSimpleBetsSelected: true,
    isBoxBetsButtonToggled: false,

    //betSlip handling
    isBetSlipModalOpen: false,
    selectedBetSlipScreen: OPEN_BETS,
    openBetsList: [],
    openBetsSimpleList: [], //this list has the open bets list but with no stake
    openBetsHistory: [], // used on simplified UI
    selectedChip: 0,
    placedBets: [],
    settledBets: [],
    betHistoryBets: [],

    betsCommitted: false,
    betsFailedBeingCommitted: false,
    betsCommitting: false,

    //modal handling
    isModalOpen: false,
    openModalType: undefined,
    // platform notifications
    notificationType: undefined,
    notificationTitle: undefined,
    notificationText: undefined,
    isNotificationLocalizable: true,
    notificationWildCards: [],
    isNotificationDismissible: true,

    // bet history (another type of modal)
    isBetHistoryOpen: false,
    selectedBetHistoryTab: ACTIVE_BETS_TAB,
    selectedBetHistoryGame: VIRTUALS[0].channel,
    filterWinsBetHistory: false,
    filterWinsSettledBets: false,
    betHistory: [],

    //odds type handling
    selectedOddsType: OPERATOR.defaultOddsFormat,

    isContainerInFullScreen: false,
    isInFullViewPlayer: false,

    isMyOffersListPopup: false,
    isHelpPagesOpen: false,
    isSettingsOpen: false,
    isAccumulatorBoostPagesOpen: false,
    isRealityCheckWarningOpen: false,
    isDemoplayNotificationOpen: false,
    betsToPlaceAfterRealityCheck: [],
    betsToPlaceAfterDemoplayCheck: [],
    isVideoVisible: (isLocalStorageAvailable && getItem(undefined, VID_VISIBLE) !== null)
        ? getItem(undefined, VID_VISIBLE)
        : true,

    isUnreadBetsNotificationToggled: false,
    isPlatformReady: false,
    serverTimeOffset: 0,
    loadingBarPercentage: undefined,
    isVideoMuted: true,
    showVirtualKeyboard: false,
    collapsedOpenBetAccordions: [],
    collapsedPlacedBetAccordions: [],
    collapsedSettledBetAccordions: [],
    isBetSlipSideView: false,
    channelEventBets: [],
    showHeader: OPERATOR.showHeader,
    showCloseButton: OPERATOR.showCloseButton,
    showCloseButtonPosition: OPERATOR.showCloseButtonPosition,
    playerLoggedIn: false,
    playerBalance: undefined,
    serverTimeZoneOffset: '',
    initialWinValSet: false,
    disabledMarkets: OPERATOR.disabledMarkets,
    matchdayMarketsOrder: OPERATOR.matchdayMarketsOrder,
    useBetBothFootball: OPERATOR.useBetBothFootball,
    useBetBothMatchday: OPERATOR.useBetBothMatchday,
    virtualKeyboardStyle: OPERATOR.virtualKeyboardStyle,
    //Matchday Dependencies
    matchday: {
        selectedMatchdayEventId: undefined
    },
    matchdayUpdated: false,
    isGiftForYouOpen: false,
    newPromoFlag: false,
    isMyOffersPopupOpen: false,
    isTermsAndConditionsPopupOpen: false,
    selectedBet :{},
    selectedPromoId:0,
    selectedTCPromoId:0,
    promoBalances:[],
    doNotShow:false,
    betSlipModalContainerHeight:0,
    onLoad: true,
    promoBannerFromWeb:[],
    // cricket modules
    cricketMarketsExpanded: ALL_CRICKET_MARKETS.map((mkt) => true),
    baseballMarketsExpanded:ALL_BASEBALL_MARKETS.map((mkt)=>true),
    tennisMarketExpanded:ALL_TENNIS_MARKETS.map((mkt)=>true),
    quickFillAutoFocusEnabled: undefined,
    accaBetAutoFocusEnabled: undefined
};


// WEBPACK FOOTER //
// ./src/constants/defaultStoreValues.js